import type { LandingOverrideComponent } from '@/types/client-landing'
import { YeshumanWorkbenchLanding } from '@/components/landing/yeshuman/yeshuman-workbench-landing'
import { getPluginSlots } from '@/plugin/slots'

/**
 * Optional full-page landing overrides per `landing.landingComponent` key.
 * Tenant packs register their own with `app.landing.component(key, Component)`.
 */
export const LANDING_OVERRIDES: Record<string, LandingOverrideComponent> = {
  yeshumanWorkbench: YeshumanWorkbenchLanding,
}

export function landingOverride(key: string | undefined): LandingOverrideComponent | undefined {
  if (!key) return undefined
  return getPluginSlots().landingComponents[key] ?? LANDING_OVERRIDES[key]
}
